<template>
    <div class="usc__student">
        <div class="usc__student-headers row">
            <div class="col-6 col-md-8">
                USC Student Optional Fees
                <div v-if="!admin" class="fee__info mb-1">
                    As an affiliate of Western, King’s students are charged for services/programs offered by
                    USC-University Students’ Council at Western. All funds collected by King’s are transferred to
                    the
                    USC. For more information about these fees, please contact the University Students’ Council at
                    <a href="mailto:info@westernusc.ca">info@westernusc.ca</a>.
                </div>
            </div>
            <div class="col-3 col-md-2">
                Value
            </div>
            <div class="col-3 col-md-2">
                Opt-Out
            </div>
        </div>
        <div class="usc__student-fees">
            <!-- <div class="row mb-2" :class="[{ 'opt__out' : governmentAdvocacy.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Government Advocacy
                        </div>
                        <div v-if="!admin" class="fee__info">Your voice is heard by Western administration and all
                            levels of
                            government through the USC. The USC advocates for increased supports for students, a safe
                            campus community, and affordable and accessible tuition. Recent advocacy wins include the
                            approval of permanent Fall Reading Week, introduction of a revised medical note policy,
                            allowance of preferred first names on university documents, investment of improved lighting
                            on campus, implementation of LTC express bus routes, and more. If you opt-out, you will
                            limit the USC's ability to advocate on your behalf and represent your interests to the
                            university and at each level of government on issues like transit, financial aid, academic
                            policies, and mental health supports.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ governmentAdvocacy.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-government-advocacy" name="usc-government-advocacy"
                            value="opt-out" v-model="governmentAdvocacy.optOut" @change="optOut(governmentAdvocacy)"
                            aria-label="government advocacy" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : studentLife.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Student Life
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can attend any of the more than 4,000 USC events that take place every year like
                            PurpleFest, BeerFest, Theatre Western performances, Rick's Wednesdays, concerts, conferences
                            and speaker series. All of these events are part of the vibrant, inclusive student
                            experience made possible through this fee, by the USC. If you opt-out, you may be charged
                            higher ticket prices or have limited access to USC events.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ studentLife.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-student-life" name="usc-student-life" value="opt-out"
                            aria-label="student life" v-model="studentLife.optOut" @change="optOut(studentLife)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : peerPrograms.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Peer Programs
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can access peer programs that are run by students, for students and that address gaps in
                            support services on campus. We support each student and their unique needs with a diverse
                            set of services which embraces and advocates with a variety of diverse ethnocultural,
                            indigenous, LGBTQ2+, and other marginalized student communities. If you opt-out, you will
                            limit the USC's ability to provide programming and support services for marginalized
                            students on campus.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ peerPrograms.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-peer-programs" name="usc-peer-programs" value="opt-out"
                            aria-label="peer programs" v-model="peerPrograms.optOut" @change="optOut(peerPrograms)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : clubsAdministration.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Clubs Administration *
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can join any of the almost 200 clubs on campus that offer events, academic support,
                            social networking, and leadership opportunities through the USC's Clubs System. This fee
                            supports the infrastructure of the system. The easiest way to get involved in clubs is to
                            visit Clubs week in September and talk to our diverse mix of clubs about what they do. If
                            you opt-out, you cannot join clubs at Western.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ clubsAdministration.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-clubs-administration" name="usc-clubs-administration"
                            aria-label="clubs administration" value="opt-out" v-model="clubsAdministration.optOut"
                            @change="optOut(clubsAdministration)" :disabled="submitted">
                    </div>
                </div>
            </div> -->
            <div v-if="getExpiredDate('orientation')" class="row mb-2"
                :class="[{ 'opt__out' : orientationWeek.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Orientation Week (1st year students only) *
                        </div>
                        <!-- <div v-if="!admin" class="fee__info">
                            Orientation Week (O-Week) takes place from September 1st - September 8th, 2024. O-Week is an
                            amazing time when the entire campus community comes together to welcome new students and
                            celebrate the start of the fall term. Our amazing orientation leaders (sophs) provide
                            mentorship and support to introduce you to our strong campus community. We’re sure you have
                            lots of questions about what Orientation Week will look like in the fall. Although COVID-19
                            has impacted the way we socialize with each other, Western and King’s are still very
                            committed to providing a safe and unforgettable Orientation Week for all incoming students!
                            O-Week events will be blended and include a mix of both in-person and virtual experiences.
                            If you opt-out, you cannot participate in Orientation Week.
                        </div> -->
                        <div v-if="!admin" class="fee__info">
                            Orientation Week (O-Week) takes place from September 1st to September 6th. 
                            You can experience diverse and exciting programming that welcomes you to King's and Western, helps you meet fellow first-year students, and facilitates your smooth introduction to campus life. 
                            Our amazing orientation leaders nd support to help you feel comfortable on campus and create a strong campus community. 
                            SOPHS lead activities and education sessions during Orientation Week and act as a resource for you throughout first year by connecting you to support and information oncampus. 
                            If you opt-out, you cannot participate in Orientation Week. <br />
                            Opt-out closes August 15th.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ orientationWeek.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-orientation-week" name="usc-orientation-week" value="opt-out"
                            aria-label="orientation week" v-model="orientationWeek.optOut"
                            @change="optOut(orientationWeek)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <!-- <div class="row mb-2" :class="[{ 'opt__out' : gazette.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Gazette
                        </div>
                        <div v-if="!admin" class="fee__info">
                            Since 1906, the Gazette has covered what matters to students. As Western's largest student
                            media outlet, we need your help to keep campus informed and entertained. If you opt-out, the
                            Gazette's coverage and training for students will be weakened.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ gazette.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-gazette" name="usc-gazette" v-model="gazette.optOut"
                            aria-label="gazette" value="opt-out" @change="optOut(gazette)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : radioWestern.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Radio Western
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can listen to radio content created by Western students and community members through
                            Radio Western, unique in London for its ability to highlight local news and culture. You can
                            also participate in their volunteer training programs and learn more about marketing and
                            promotions, conducting interviews, writing and airing news reports, sports broadcasting, and
                            radio production. If you opt-out, you will limit Radio Western's ability to cover campus
                            news and provide professional development opportunities in radio to all undergraduate
                            students.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ radioWestern.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-radio-western" name="usc-radio-western" value="opt-out"
                            aria-label="radio western" v-model="radioWestern.optOut" @change="optOut(radioWestern)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : studentRefugeeProgram.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Student Refugee Program
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can support student refugees attending Western University in a safe and supportive
                            environment in Canada. This unique program includes academic supports to help with both the
                            resettlement and university experience. If you opt-out, you will reduce the funding
                            available to student refugees through this program.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ studentRefugeeProgram.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-student-refugee-program" name="usc-student-refugee-program"
                            aria-label="student refugee program" value="opt-out" v-model="studentRefugeeProgram.optOut"
                            @change="optOut(studentRefugeeProgram)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : daycare.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Daycare
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can help support students with children by providing them with safe, convenient, and
                            accessible childcare on campus. This helps remove barriers to education, enabling more
                            students to attend university. If you opt-out, you will reduce the funding available to
                            support students with children through this program.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ daycare.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-daycare" name="usc-daycare" v-model="daycare.optOut"
                            aria-label="daycare" value="opt-out" @change="optOut(daycare)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : marchingBand.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Marching Band
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can support the tradition and excellence of the Western Marching Band! Established in
                            1937, they perform at athletic games, parades and festivals and are one of the largest
                            marching bands in Canada. If you opt-out, you will limit the Marching Band's ability to
                            perform at events and promote school spirit at Western.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ marchingBand.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-marching-band" name="usc-marching-band" value="opt-out"
                            aria-label="marching band" v-model="marchingBand.optOut" @change="optOut(marchingBand)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : communityLegalServices.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Community Legal Services
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can help provide free legal advice and representation to Western students and members of
                            the London community through Community Legal Services. Legal services are funded by
                            Western's University Students' Council, Western's Faculty of Law, the Fanshawe Student
                            Union, Legal Aid Ontario, and the Law Foundation of Ontario. If you opt-out, you will reduce
                            the funding available to support recipients of free Community Legal Services through this
                            program.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ communityLegalServices.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="usc-community-legal-services" name="usc-community-legal-services"
                            aria-label="community legal services" value="opt-out"
                            v-model="communityLegalServices.optOut" @change="optOut(communityLegalServices)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row" :class="[{ 'opt__out' : facultyAffiliateCouncils.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Faculty and Affiliate Councils
                        </div>
                        <div v-if="!admin" class="fee__info">
                            You can experience exciting events and leadership opportunities with people in your faculty,
                            or affiliate university-college (Huron, Brescia, Kings) by supporting Faculty and Affiliate
                            Councils. These councils host concerts, guest speakers, academic conferences, and more. They
                            also advocate for student needs at a faculty and/or affiliate university-college level. If
                            you choose to opt-out, you will reduce the funding available for your academic faculty or
                            affiliate university-college.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ facultyAffiliateCouncils.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="usc-faculty-affiliate-councils" name="usc-faculty-affiliate-councils"
                            aria-label="faculty and affiliate councils" value="opt-out"
                            v-model="facultyAffiliateCouncils.optOut" @change="optOut(facultyAffiliateCouncils)"
                            :disabled="submitted">
                    </div>
                </div>
            </div> -->
        </div>
        <div :class="[total > 0 ? 'usc__student-fee' : 'usc__student-nofee', 'usc__student-total']">
            <div class="row">
                <div class="col-6 col-md-8">
                    Total USC Student Optional Fees
                </div>
                <div class="col-6 col-md-4">
                    $ {{ total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-usc-student',
    props: {
        admin: {
            type: Boolean
        },
        expiringFields: {
            type: Array
        },
        userData: {
            type: Object
        },
        submitted: {
            type: Boolean
        }
    },
    data() {
        return {
            governmentAdvocacy: {
                amount: "8.75",
                optOut: false
            },
            studentLife: {
                amount: "15.88",
                optOut: false
            },
            peerPrograms: {
                amount: "3.20",
                optOut: false
            },
            clubsAdministration: {
                amount: "7.71",
                optOut: false
            },
            orientationWeek: {
                amount: "146.02",
                optOut: false
            },
            gazette: {
                amount: "19.43",
                optOut: false
            },
            radioWestern: {
                amount: "12.24",
                optOut: false
            },
            studentRefugeeProgram: {
                amount: "0.83",
                optOut: false
            },
            daycare: {
                amount: "1.60",
                optOut: false
            },
            marchingBand: {
                amount: "0.54",
                optOut: false
            },
            communityLegalServices: {
                amount: "5.72",
                optOut: false
            },
            facultyAffiliateCouncils: {
                amount: "4.24",
                optOut: false
            },
            total: "0.00"
        }
    },
    methods: {
        optOut(fee) {
            // Opt-out calcuation
            if (!fee.optOut) {
                this.total = Number.parseFloat(this.total) + Number.parseFloat(fee.amount);
            } else {
                this.total = Number.parseFloat(this.total) - Number.parseFloat(fee.amount);
            }

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);

            // Update sci total fees
            this.$emit('getUscTotal', this.total);
        },
        getExpiredDate(fee) {

            if (this.expiringFields && this.expiringFields.length > 0) {
                var regex = new RegExp(fee, 'i');
                var expFee = this.expiringFields.find(function (input) {
                    return input.key.match(regex);
                });

                if (expFee) {
                    var expDate = new Date(expFee.date);
                    var currDate = new Date;

                    if (expDate.getTime() <= currDate.getTime()) {
                        return false
                    }
                }
            }

            return true;
        },
        getFee(fee) {
            // if (fee.match(/advocacy$/i)) {
            //     return this.governmentAdvocacy;
            // } else if (fee.match(/life$/i)) {
            //     return this.studentLife;
            // } else if (fee.match(/peer/i)) {
            //     return this.peerPrograms;
            // } else if (fee.match(/administration$/i)) {
            //     return this.clubsAdministration;
            // } else 
            if (fee.match(/orientation/i)) {
                return this.orientationWeek;
            }
            // else if (fee.match(/gazette$/i)) {
            //     return this.gazette;
            // } else if (fee.match(/radio/i)) {
            //     return this.radioWestern;
            // } else if (fee.match(/refugee/i)) {
            //     return this.studentRefugeeProgram;
            // } else if (fee.match(/daycare/i)) {
            //     return this.daycare;
            // } else if (fee.match(/marching/i)) {
            //     return this.marchingBand;
            // } else if (fee.match(/community/i)) {
            //     return this.communityLegalServices;
            // } else if (fee.match(/councils$/i)) {
            //     return this.facultyAffiliateCouncils;
            // } 
            else {
                return false;
            }
        },
        getTotalFees() {
            // Total float calculation
            this.total =
                // Number.parseFloat(this.governmentAdvocacy.amount) +
                // Number.parseFloat(this.studentLife.amount) +
                // Number.parseFloat(this.peerPrograms.amount) +
                // Number.parseFloat(this.clubsAdministration.amount) +
                Number.parseFloat(this.orientationWeek.amount);
            // Number.parseFloat(this.gazette.amount) +
            // Number.parseFloat(this.radioWestern.amount) +
            // Number.parseFloat(this.studentRefugeeProgram.amount) +
            // Number.parseFloat(this.daycare.amount) +
            // Number.parseFloat(this.marchingBand.amount) +
            // Number.parseFloat(this.communityLegalServices.amount) +
            // Number.parseFloat(this.facultyAffiliateCouncils.amount);

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);
        }
    },
    created() {
        // Total USC Optional Fees
        this.getTotalFees();

        // Update sci total fees
        this.$emit('getUscTotal', this.total);

        // Formdata handler
        if (this.userData.result && this.userData.result.match(/^OK/i)) {
            if (this.userData.data && this.userData.data.length > 0) {
                let formData = this.userData.data;

                formData.forEach((record) => {
                    let key = record.key;
                    let fee = this.getFee(key);

                    if (fee) {
                        fee.optOut = true;
                        this.optOut(fee);
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.usc__student {
    margin-bottom: 1.25rem;
}

.usc__student-fees {
    border-bottom: 1px solid black;
    padding-bottom: .5rem;
}

.usc__student-headers {
    font-size: 16px;
    font-weight: 600;
}

.usc__student-total {
    font-size: 16px;
    font-weight: 600;
}

.usc__student-fee {
    color: #3455db;
}

.usc__student-nofee {
    color: #008040;
}
</style>